// ContentOperationViewDto.js

class ContentOperationViewDto {
    actionType = String();
    actionDetail = String();

    actionDate = String();
    sessionId = String();
    destinationOrgId = String();
    destinationOrgDomain = String();
    destinationOrgName = String();
    destinationPrjId = String();
    destinationPrjName = String();
    orgActionId = String();
    orgActionDomain = String();
    orgActionName = String();
    prjActionId = String();
    prjActionName = String();
    userActionId = String();
    userActionEmail = String();
    userActionName = String();

    contentTypes = String();
    ticketId = String();
    ticketName = String();
    creatorId = String();
    creatorEmail = String();
    creatorName = String();
    formatId = String();
    formatName = String();

    escalationTicketId = String();
    escalationTicketName = String();
    elapsedTime = String();
    publicRange = String();
    outline = String();
    
    assigneeId = String();
    assigneeEmail = String();
    assigneeName = String();
    // userDefinedFields = String();
    operationScreen = String();
    viewBy = String();

    constructor(data) {
        this.actionType = data.actionType || null;
        this.actionDetail = data.actionDetail || null;

        this.actionDate = data.actionDate || null;
        this.sessionId = data.sessionId || null;
        this.destinationOrgId = data.destinationOrgId || null;
        this.destinationOrgDomain = data.destinationOrgDomain || null;
        this.destinationOrgName = data.destinationOrgName || null;
        this.destinationPrjId = data.destinationPrjId || null;
        this.destinationPrjName = data.destinationPrjName || null;
        this.orgActionId = data.orgActionId || null;
        this.orgActionDomain = data.orgActionDomain || null;
        this.orgActionName = data.orgActionName || null;
        this.prjActionId = data.prjActionId || null;
        this.prjActionName = data.prjActionName || null;
        this.userActionId = data.userActionId || null;
        this.userActionEmail = data.userActionEmail || null;
        this.userActionName = data.userActionName || null;

        this.contentTypes = data.contentTypes || null;
        this.ticketId = data.ticketId || null;
        this.ticketName = data.ticketName || null;
        this.creatorId = data.creatorId || null;
        this.creatorEmail = data.creatorEmail || null;
        this.creatorName = data.creatorName || null;
        this.formatId = data.formatId || null;
        this.formatName = data.formatName || null;

        this.escalationTicketId = data.escalationTicketId || null;
        this.escalationTicketName = data.escalationTicketName || null;
        this.elapsedTime = data.elapsedTime || null;
        this.publicRange = data.publicRange || null;
        this.outline = data.outline || null;

        this.assigneeId = data.assigneeId || null;
        this.assigneeEmail = data.assigneeEmail || null;
        this.assigneeName = data.assigneeName || null;
        // this.userDefinedFields = data.userDefinedFields;
        this.operationScreen = data.operationScreen || null;
        this.viewBy = data.viewBy || null
    }
}

export default ContentOperationViewDto;
